export default __webpack_public_path__ + "static/media/location-drop-pin.inline.0ba5b9a3.svg";